/* Vexon enhances native disclosure/navigation only; commerce belongs to Dawn. */
(() => {
  if (window.vexonNavigationReady) return;
  window.vexonNavigationReady = true;
  const navSelector = '[data-vx-mobile-menu], .vx-nav-group';
  const closeMenus = (except) => document.querySelectorAll(`${navSelector.split(',').map(s=>`${s.trim()}[open]`).join(',')}`).forEach(menu => {
    if (menu !== except) menu.open = false;
  });
  document.addEventListener('click', event => {
    const menu = event.target.closest(navSelector);
    if (!menu) closeMenus();
    else if (event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest(navSelector);
    if (menu?.open) { menu.open = false; menu.querySelector('summary')?.focus(); }
    else closeMenus();
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.(navSelector) && event.target.open) closeMenus(event.target);
  }, true);
  const desktop = matchMedia('(min-width: 990px)');
  desktop.addEventListener('change', () => closeMenus());
})();
